@if (navigated() && authState.confirmed()) {
  <szz-container></szz-container>
} @else if (navigated()) {
  <!-- An unguarded page (/error) without a confirmed session: the page alone, no header or sidebar. -->
  <router-outlet></router-outlet>
} @else {
  <div class="d-flex justify-content-center mt-5" role="status">
    <span class="spinner-border text-primary" aria-hidden="true"></span>
    <span class="visually-hidden">Nalaganje …</span>
  </div>
}
